import { Routes } from '@angular/router';

import { AUTH_ROUTES } from './auth/auth.routes';
import { AuthGuard } from './auth/guard/auth-guard.guard';
import { childRoutesGuard } from './auth/guard/child-routes-guard';
import { BIOLOGICAL_SAMPLING_ROUTES } from './domains/biological-sampling/biological-sampling.routes';
import { FLEET_MANAGEMENT_ROUTES } from './domains/fleet-management/fleet-management.routes';
import { GRAPHS_ROUTES } from './domains/graphs/graphs.routes';
import { LANDING_INSPECTION_ROUTES } from './domains/landing-inspection/landing-inspection.routes';
import { SETTINGS_ROUTES } from './domains/settings/settings.route';

export const routes: Routes = [
  {
    path: '',
    children: AUTH_ROUTES,
  },
  {
    path: 'dashboard',
    canActivate: [AuthGuard],
    canActivateChild: [childRoutesGuard],
    loadComponent: () =>
      import('./domains/dashboard.component').then(m => m.DashboardComponent),
    children: [
      {
        path: 'home',
        loadComponent: () =>
          import('./domains/home/home-page/home-page.component').then(
            m => m.HomePageComponent
          ),
      },
      {
        path: 'inspections',
        children: LANDING_INSPECTION_ROUTES,
      },
      {
        path: 'research',
        children: BIOLOGICAL_SAMPLING_ROUTES,
      },
      {
        path: 'catalogs',
        children: FLEET_MANAGEMENT_ROUTES,
      },
      {
        path: 'graphs',
        children: GRAPHS_ROUTES,
      },
      {
        path: 'settings',
        children: SETTINGS_ROUTES,
      },
      {
        path: '',
        redirectTo: 'home',
        pathMatch: 'full',
      },
      {
        path: 'forbidden',
        loadComponent: () =>
          import(
            './domains/forbidden-resource/forbidden-resource.component'
          ).then(m => m.ForbiddenResourceComponent),
      },
    ],
  },
  { path: '**', redirectTo: 'login' },
];
